import React, { memo } from 'react'

import { EXCHANGE_ACCOUNT_ACTION } from '../../../constants/exchangeProvider'
import customConfig from 'customConfig'
import ScanQrCode from '../../shared/scanQrCode/ScanQrCode'

const ConnectAccountByQrCode = ({
  t,
  accountAction = EXCHANGE_ACCOUNT_ACTION.CONNECT,
  ...restProps
}) => {
  return (
    <ScanQrCode
      title={t(`exchange.${accountAction}-account`)}
      description={t(customConfig.scanQrCodeConnectAccountLabel, {
        label: t(`exchange.${accountAction}`).toLowerCase()
      })}
      cancelLabel={t('common.cancel')}
      {...restProps}
    />
  )
}

export default memo(ConnectAccountByQrCode)
